<template>
  <div class="Layout-header">
    <div class="box">
      <!-- 头像 -->
      <!-- <el-avatar size="large" :src="imgUrl"></el-avatar> -->
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          欢迎你，{{ username }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <!-- 下拉选项 -->
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出系统</el-dropdown-item>
          <el-dropdown-item command="logpwd">修改密码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import local from "@/utils/local";
export default {
  data() {
    return {
      imgUrl:
        "https://img0.baidu.com/it/u=3311900507,1448170316&fm=26&fmt=auto&gp=0.jpg",
      username: "",
    };
  },
  created () {
    this.username=local.get('username');
  },
  methods: {
    handleCommand(command) {
      if (command === "logout") {
        this.$message({
          type: "success",
          message: "恭喜你，退出成功",
        });
        local.clear();
        this.$router.push("/login");
        // window.location.reload(); //刷新
      } else if (command === "logpwd") {
        //    console.log('修改密码')
        this.$router.push("/acc-pwd");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.Layout-header {
  height: 72px;
  background: #324157;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 50px;
  // justify-content: space-between;
  .box {
    display: flex;
    align-items: center;

    .el-avatar {
      margin-right: 20px;
    }
    .el-dropdown {
      color: #fff;
    }
  }
}
</style>